<template>
  <footer class="footer">
    <div class="footer-container">
      <loop-box
        v-if="payLoopArr.length > 0 && !isLandscape"
        :title="letter.v3SupportPay"
        :listData="payLoopArr"
        :itemStyle="payLoopArrStyle"
        :classOption="{
          limitMoveNum: 4,
          direction: 2
        }"
      ></loop-box>
      <loop-box
        v-if="communityLoopArr.length > 0 && !isLandscape"
        :title="letter.v3FollowOur"
        :listData="communityLoopArr"
        :itemStyle="communityLoopArrStyle"
      ></loop-box>
      <div class="right">
        <loop-box
          v-if="communityLoopArr.length > 0 && isLandscape"
          :title="letter.v3FollowOur"
          :listData="communityLoopArr"
          :itemStyle="communityLoopArrStyle"
          :classOption="{
            limitMoveNum: 13,
            direction: 2
          }"
        ></loop-box>
        <safe-footer></safe-footer>
      </div>
      <div class="left">
        <loop-box
          v-if="payLoopArr.length > 0 && isLandscape"
          :title="letter.v3SupportPay"
          :listData="payLoopArr"
          :itemStyle="payLoopArrStyle"
        ></loop-box>
        <div class="link-box">
          <a
            class="service-link link"
            href="javascript:;"
            @click="openServiceLink"
            >{{ letter.fwtk }}</a
          >
          <a
            class="policy-link link"
            href="javascript:;"
            @click="openPrivacyLink"
            >{{ letter.yszc }}</a
          >
          <a
            v-if="paypricyLink && paypricy"
            href="javascript:;"
            @click="openPaypricyLink"
            class="policy-link link"
            >{{ paypricy }}</a
          >
          <a
            v-if="showCustomize"
            href="javascript:;"
            @click="openJpServicePrivacyLink"
            class="policy-link link"
            >資金決済法に基づく表示</a
          >
          <a
            v-if="showCustomize"
            href="javascript:;"
            @click="openJpCustomizeLink"
            class="policy-link link"
            >特定商取引法に基づく表示</a
          >
        </div>
        <p class="copyright" v-html="copyright"></p>
      </div>
    </div>
  </footer>
</template>

<script>
import SafeFooter from '@components/officialTopupNew/SafeFooter.vue';
import LoopBox from '@components/officialTopupNew/common/LoopBox.vue';
import globalConfig from '@utiles/officialStore/globalConfig';
import { getGameLanguage } from '@store/languages/gameConf';
import serviceLink from '@mixins/officialTopupNew/serviceLink';
import { getCopyright } from '@utiles/reviewFooter';
import { mapGetters, mapState } from 'vuex';
import { PAYTYPE_ICON_URL } from '@utiles/officialStore';
import { filterPayTypeShow } from '@store/_tempAllStoreHanlder';

import MEDIA_BAHAMUTE_ICON from '@assets/image/officialTopupNew/media/media-bahamute.png';
import MEDIA_DISCORD_ICON from '@assets/image/officialTopupNew/media/media-discord.png';
import MEDIA_FACEBOOK_ICON from '@assets/image/officialTopupNew/media/media-facebook.png';
import MEDIA_NAVER_ICON from '@assets/image/officialTopupNew/media/media-naver.png';
import MEDIA_TIKTOK_ICON from '@assets/image/officialTopupNew/media/media-tiktok.png';
import MEDIA_TWITTER_ICON from '@assets/image/officialTopupNew/media/media-twitter.png';
import MEDIA_YOUTUBE_ICON from '@assets/image/officialTopupNew/media/media-youtube.png';

export default {
  name: 'pageFooter',
  mixins: [serviceLink],
  data() {
    let copyright = `COPYRIGHT © ${location.host.toUpperCase()} ALL RIGHTS RESERVED.`;
    // 2024.08.23 邓智轩：送审域名+对应游戏+带参数p=rupay时替换copyright
    let gameId =
      globalConfig.getHrefParam('gameId') ||
      globalConfig.getHrefParam('game_id') ||
      globalConfig.getHrefParam('gameID') ||
      '';
    return {
      copyright: getCopyright(gameId) || copyright
    };
  },
  computed: {
    ...mapState({
      isLandscape: state => state.page.isLandscape,
      curLocation: state => state.curLocation
    }),
    ...mapGetters(['isJpPlatform']),
    payLoopArrStyle() {
      return this.isLandscape
        ? {
            width: '100px', // safari浏览器的空间计算很严格，需要保留1px像素的位置，原来是写了101px的
            height: '40px',
            borderRadius: '10px',
            backgroundColor: '#ffffff'
          }
        : {
            width: '116px',
            height: '46px',
            borderRadius: '6px',
            backgroundColor: '#E7E7E7'
          };
    },
    communityLoopArrStyle() {
      return this.isLandscape
        ? {
            width: '40px',
            height: '40px'
          }
        : {
            width: '68px',
            height: '68px'
          };
    },
    letter() {
      return this.$store.state.letter;
    },
    lang() {
      return this.$store.state.lang;
    },
    paypricyLink() {
      return getGameLanguage('', 'paypricyLink', this.gameId);
    },
    paypricy() {
      return getGameLanguage('', 'paypricy', this.gameId);
    },
    gameId() {
      return this.$store.state.gameId;
    },
    payLoopArr() {
      let payTypeList = this.$store.state.payTypeList;
      payTypeList = filterPayTypeShow(
        { gameId: this.gameId, location: this.curLocation },
        payTypeList
      );
      return payTypeList?.map?.(item => {
        return {
          icon: this.getCurPayWayIcon(item.f_pay_type, item.pay_type, item.cid),
          link: ''
        };
      });
    },
    communityLoopArr() {
      const ICON_MAP = {
        bahamute: MEDIA_BAHAMUTE_ICON,
        discord: MEDIA_DISCORD_ICON,
        facebook: MEDIA_FACEBOOK_ICON,
        naver: MEDIA_NAVER_ICON,
        tiktok: MEDIA_TIKTOK_ICON,
        twitter: MEDIA_TWITTER_ICON,
        youtube: MEDIA_YOUTUBE_ICON
      };
      return this.$store.state.page.socialLink
        ?.map?.(item => {
          return {
            icon:
              ICON_MAP[item.type] ||
              this.$store.state.page.picList?.[item.type] ||
              '',
            link: item?.url || ''
          };
        })
        ?.filter?.(item => item.icon && item.link);
    },
    showCustomize() {
      return +this.gameId === 454 && this.lang === 'ja-JP';
    }
  },
  methods: {
    openPaypricyLink() {
      this.openLink(this.paypricyLink);
    },
    getCurPayWayIcon(fpt, pt, cid) {
      // 特殊处理代币先用游戏ico，渠道名称：日本平台叫points_pay，全球平台叫user_balance_pay
      const channelName = this.isJpPlatform ? 'points_pay' : 'user_balance_pay';
      if (fpt === channelName && pt === channelName) {
        return `${PAYTYPE_ICON_URL}${fpt}/gameid_${this.gameId}_${pt}.png`;
      }
      return `${PAYTYPE_ICON_URL}${fpt}/${pt}${
        cid &&
        fpt == this.selectedPaytpe.f_pay_type &&
        pt == this.selectedPaytpe.pay_type
          ? `/${cid}`
          : ''
      }.png`;
    }
  },
  components: {
    SafeFooter,
    LoopBox
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/_dimen.scss';
.footer {
  color: #333333;
  position: relative;
  width: 100%;
  padding: 0 40px 40px;
  box-sizing: border-box;

  .footer-container {
    width: 100%;
    background-color: $moduleBackgroundColor;
    border-radius: 20px;
    box-sizing: border-box;
    padding: 40px 20px;

    .left {
      width: 100%;
      margin: 10px 0;

      .copyright {
        text-align: center;
        font-size: 20px;
        line-height: 1.5;
      }

      .link-box {
        text-align: center;
        position: relative;
        margin-bottom: 30px;
      }

      .link {
        margin-right: 20px;
        display: inline-block;
        font-size: 20px;
        color: #333333;
        text-decoration: none;
        cursor: pointer;
        margin-bottom: 15px;
      }

      .link + .link {
        &::before {
          content: '|';
          margin-right: 20px;
        }
      }
    }
    .right {
      width: 100%;
    }
  }
}

#ssr-page.landscape {
  .footer {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    padding: 47px 0 0 0;
    background-color: #111111;
    color: #f6f6f6;

    .footer-container {
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
      align-items: flex-start;
      max-width: 1500px;
      margin: 0 auto;
      padding: 0;
      background-color: #111111;

      .left {
        width: 50%;
        margin: 0;

        &-loop {
          margin-bottom: 40px;
        }

        .copyright {
          text-align: start;
          font-size: 14px;
          line-height: 1.5;
        }

        .link-box {
          text-align: start;
          margin-bottom: 20px;
        }

        .link {
          margin-right: 20px;
          display: inline-block;
          font-size: 14px;
          color: #f6f6f6;
          text-decoration: none;
          cursor: pointer;
          margin-bottom: 0;
        }

        .link + .link {
          &::before {
            content: '|';
            margin-right: 20px;
          }
        }
      }

      .right {
        width: 50%;
      }
    }
  }
}
</style>
